module.exports = __webpack_public_path__ + "img/excalibur.9bf9db7e.jpg";